import { render, staticRenderFns } from "./TBmSerialnoModal.vue?vue&type=template&id=0aa08d92&"
import script from "./TBmSerialnoModal.vue?vue&type=script&lang=js&"
export * from "./TBmSerialnoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa08d92')) {
      api.createRecord('0aa08d92', component.options)
    } else {
      api.reload('0aa08d92', component.options)
    }
    module.hot.accept("./TBmSerialnoModal.vue?vue&type=template&id=0aa08d92&", function () {
      api.rerender('0aa08d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/TBmSerialnoModal.vue"
export default component.exports